import { Component, Inject, LOCALE_ID, ViewChild, OnInit, Injector, input } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { NgOptimizedImage } from '@angular/common';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { ThemeService, KeycloakService, SettingsDrawerService } from '@nagel-services';
import { Router } from '@angular/router';
import { IconComponent } from '@nagel-assests';

@Component({
    selector: 'lib-settings-drawer',
    providers: [],
    imports: [
        MatToolbarModule,
        IconComponent,
        MatButtonModule,
        NgOptimizedImage,
        MatSidenavModule
    ],
    templateUrl: './settings-drawer.component.html',
    styleUrl: './settings-drawer.component.scss'
})
export class SettingsDrawerComponent implements OnInit {
    @ViewChild('drawer') drawer: MatDrawer | undefined;
    profilePicturePath = input<string>('/assets/profile_picture.webp');

    private themeService: ThemeService;
    private keycloakService: KeycloakService;
    private settingsDrawerService: SettingsDrawerService;

    constructor(
        private injector: Injector,
        @Inject(LOCALE_ID) private localeId: string,
        private router: Router
    ) {
        this.themeService = this.injector.get(ThemeService);
        this.keycloakService = this.injector.get(KeycloakService);
        this.settingsDrawerService = this.injector.get(SettingsDrawerService);
    }

    onLogout = () => {
        this.keycloakService.logout();
        this.router.navigate(['/transport']);
    };

    onCloseClick(): void {
        this.settingsDrawerService?.toggleDrawer();
    }

    ngOnInit() {
        this.settingsDrawerService.settingsDrawerToggleSubject.subscribe(() => {
            this.drawer?.toggle();
        });
    }

    onDrawerClosed(): void {
        this.settingsDrawerService.setDrawerOpened(false);
    }

    getIconToShow = () => {
        return this.themeService.isDarkTheme() ? 'nagel_text_icon_dark' : 'nagel_text_icon_light';
    };
}